import { Box, Skeleton, Stack } from "@mui/material";

const DAYS_IN_WEEK = 7;
const WEEKS_TO_SHOW = 6;
const MONTHS_MOBILE = 12;

function MonthSkeleton({ stickyHeader = false }: { stickyHeader?: boolean }) {
  return (
    <Box sx={{ flex: 1, p: 1 }}>
      {/* Month header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          py: 1.5,
          ...(stickyHeader && {
            position: "sticky",
            top: 0,
            zIndex: 1,
            bgcolor: "background.paper",
          }),
        }}
      >
        <Skeleton variant="text" width={100} height={24} />
      </Box>

      {/* Weekday headers */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: `repeat(${DAYS_IN_WEEK}, 1fr)`,
          gap: 0.5,
          py: 1,
          borderTop: 1,
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        {Array.from({ length: DAYS_IN_WEEK }).map((_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton array, no meaningful ID
          <Box key={i} sx={{ display: "flex", justifyContent: "center" }}>
            <Skeleton variant="text" width={20} height={16} />
          </Box>
        ))}
      </Box>

      {/* Day cells */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: `repeat(${DAYS_IN_WEEK}, 1fr)`,
          gap: 0.5,
          mt: 1,
        }}
      >
        {Array.from({ length: DAYS_IN_WEEK * WEEKS_TO_SHOW }).map((_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton array, no meaningful ID
          <Box key={i} sx={{ display: "flex", justifyContent: "center", py: 0.5 }}>
            <Skeleton variant="circular" width={28} height={28} />
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default function DateRangeCalendarSkeleton() {
  return (
    <>
      {/* Mobile: 12 months stacked vertically, no navigation, sticky month headers */}
      <Box sx={{ display: { xs: "block", sm: "none" } }}>
        {Array.from({ length: MONTHS_MOBILE }).map((_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton array, no meaningful ID
          <MonthSkeleton key={i} stickyHeader />
        ))}
      </Box>

      {/* Desktop: 2 months side by side with navigation buttons */}
      <Box sx={{ position: "relative", display: { xs: "none", sm: "block" } }}>
        <Box sx={{ position: "absolute", top: 12, left: 16, zIndex: 1 }}>
          <Skeleton variant="circular" width={40} height={40} />
        </Box>
        <Box sx={{ position: "absolute", top: 12, right: 16, zIndex: 1 }}>
          <Skeleton variant="circular" width={40} height={40} />
        </Box>
        <Stack direction="row" divider={<Box sx={{ borderLeft: 1, borderColor: "divider" }} />}>
          <MonthSkeleton />
          <MonthSkeleton />
        </Stack>
      </Box>
    </>
  );
}
